module.exports = __webpack_public_path__ + "static/media/friends.eb4b027c.svg";